import React from "react";

import { SelectStyled, SelectRoot } from "./SelectStyled.js";

const Select = ({ children, onClickIcon = () => {}, ...rest }) => {
  return (
    <SelectRoot>
       {/* {icon && <SpanStyled onClick={onClickIcon}>{icon}</SpanStyled>} */}
      <SelectStyled {...rest}>
        {children}
      </SelectStyled>
    </SelectRoot>
    
  );
};

export default Select;
